import { render, staticRenderFns } from "./MonthlySocsoHLB.vue?vue&type=template&id=9577e678"
import script from "./MonthlySocsoHLB.vue?vue&type=script&lang=js"
export * from "./MonthlySocsoHLB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports